module.exports = __webpack_public_path__ + "static/media/advertisers_decorative_section2.21ec76a8.png";